module.exports = __webpack_public_path__ + "6b74ea14.svg";